import assessmentReviewMeetingReducer from "./assessmentReviewMeetingReducer";

const assessmentReviewMeetingReducers = {
    assessmentReviewMeeting: assessmentReviewMeetingReducer
}

export default assessmentReviewMeetingReducers;